module.exports = __webpack_public_path__ + "static/img/mj3.4120a4a7.png";